import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OnboardingService } from '../../../core/services/onboarding.service.ts.service';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  AbstractControl,
  ValidationErrors,
  AsyncValidatorFn,
} from '@angular/forms';
import { IconComponent } from '../../../shared/icon/icon.component';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-stepSelectCompany',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, IconComponent],
  templateUrl: './stepSelectCompany.component.html',
  styleUrl: './stepSelectCompany.component.scss',
})
export class StepSelectCompanyComponent implements OnInit {
  constructor(
    private router: Router,
    private onboardingService: OnboardingService,
    private formBuilder: FormBuilder
  ) {
    this.selectCompanyForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  selectCompanyForm: FormGroup;

  ngOnInit(): void {
    // Recupero i dati salvati dal servizio
    const onboardingData = this.onboardingService.getData();

    if (onboardingData) {
      // Precompilo i campi del form se i dati sono disponibili
      this.selectCompanyForm.patchValue({
        email: onboardingData.email || '',
      });
    }
  }

  onSubmit() {
    if (this.selectCompanyForm.valid) {
      this.nextStep();
    }
  }

  nextStep() {
    const selectCompanyFormData = {
      email: this.selectCompanyForm.get('email')?.value.trim(),
    };

    this.onboardingService.updateData({
      stepSelectCompanyCompleted: true,
      stepUserInfoCompleted: true, // Skipping user info step
      // Default values for mandatory backend fields
      firstName: '',
      lastName: '',
      gender: 'MALE',
      birthDate: '',
      birthCountry: 'Italia',
      birthCity: 'Milano',
      groupRef: 'Ambassador-Program',
      drfeelUser: true,
      ...selectCompanyFormData,
    });
    this.router.navigate(['description']);
  }
}
